import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import getHistory from '../../../helpers/rounting/getHistory'
import { Alert, Button, Modal, Input, notification, Radio, Typography, Select } from 'antd'
import ErrorList from '../../list-unpush-kit-card/components/errorList'
import queryString from "query-string"
import {
    createBatchByNumberV3,
    listPartner,
    listLevels
} from "../../../services/api/3dApi"

const { TextArea } = Input
const { Text } = Typography
const { Option } = Select

const UnpushEmbroideryCreateBatch = ({ onResetAction, query, orders = [], openModal = false, showBtn, resetOpenModal, resetSelectItems }) => {
    const [isOpen, setIsOpen] = useState(openModal)
    const [loading, setLoading] = useState(false)
    const [message, setMessage] = useState('')
    const [name, setName] = useState([]) // array of templates
    const [string, setString] = useState('')
    const [userCreate, setUserCreate] = useState('')
    const [levels, setLevels] = useState([])
    const [level, setLevel] = useState("1")
    const [error, setError] = useState('')
    const [partner, setPartner] = useState('')
    const [partners, setPartners] = useState([])
    const [errorPartner, setErrorPartner] = useState('')

    useEffect(() => {
        setIsOpen(openModal)
    }, [openModal])

    // Effect: when modal opens, initialize from props.orders and fetch lists
    useEffect(() => {
        if (isOpen) {
            // replicate original logic (original computed listBarcodes but didn't use it)
            const listBarcodes = orders.map(i => {
                const { marketplace, item_number } = Object.assign({}, i)
                if (!!marketplace && !!item_number) {
                    return `${marketplace}_${item_number}`
                }
                return undefined
            }).filter(Boolean)

            // original set string: orders.join('\n'), name: orders
            try {
                setString(Array.isArray(orders) ? orders.join('\n') : '')
            } catch (e) {
                setString('')
            }
            setName(Array.isArray(orders) ? orders : [])

            // fetch levels and partners
            _fetchLevel()
            _fetchPartner()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen]) // run when isOpen changes

    const _handleChange = e => {
        const { value } = e.target
        setString(value)

        // split by many separators and filter empties
        const arr = value.split(/#|\r|\n|\t|\r\n|\s|,\s|,/)
        const newArr = arr.filter(item => item !== '')
        setName(newArr)
    }

    const _handleChangeText = (e) => {
        const { value } = e.target
        setUserCreate(value.trim())
    }

    const _onChangeRadio = (e) => {
        setLevel(e.target.value)
    }

    const _onChangeSelect = (value) => {
        setPartner(value)
    }

    const _handleSubmit = async (e) => {
        if (e && e.preventDefault) e.preventDefault()

        setLoading(true)
        setMessage('')

        if (!name || name.length === 0) {
            setLoading(false)
            setMessage('Vui lòng nhập vào một mã order')
            return
        }

        try {
            const payload = {
                templates: name,
                user_create: userCreate,
                level: level,
                partner: partner
            }

            const { data: response } = await createBatchByNumberV3(payload)
            const { success, error: errMsg, data } = response

            if (!success) {
                throw new Error(errMsg)
            } else {
                setLoading(false)
                setIsOpen(false)
                if (!!resetOpenModal) resetOpenModal(false)
                if (!!resetSelectItems) resetSelectItems()

                const { errorResult } = data
                const { _id } = data.batch || {}

                if (errorResult && errorResult.length > 0) {
                    notification.error({
                        message: 'ERROR',
                        description: <ErrorList list={errorResult} />,
                        duration: 0,
                    })
                }

                if (_id) {
                    const history = getHistory()
                    history.push(`/batches/${_id}`)
                }
            }
        } catch (err) {
            setLoading(false)
            setMessage(err.message || 'Có lỗi xảy ra')
        }
    }

    const _fetchPartner = async () => {
        try {
            const payload = {
                type: 'print_partner'
            }
            const queryStr = queryString.stringify(payload)

            const { data: response } = await listPartner(queryStr)
            const { data: resData, success, error: errMsg } = response

            if (!success) {
                setErrorPartner(errMsg)
                return
            }

            setPartners(resData.partners || [])
        } catch (e) {
            setErrorPartner(e.message)
        }
    }

    const _fetchLevel = async () => {
        try {
            const { data: response } = await listLevels()
            const { data: resData, success, error: errMsg } = response

            if (!success) {
                setError(errMsg)
                return
            }

            setLevels(resData || [])
        } catch (e) {
            setError(e.message)
        }
    }

    const _closeModal = () => {
        setIsOpen(false)
        if (!!resetOpenModal) resetOpenModal(false)
        if (!!resetSelectItems) resetSelectItems()
    }

    const _openModal = () => {
        setIsOpen(true)
    }

    const modalFooter = [
        <Button key='btnCancelBulkAction1' onClick={_closeModal} disabled={loading}>Hủy</Button>,
        <Button loading={loading} key='btnOKBulkAction1' type='primary'
            onClick={_handleSubmit}
            disabled={loading || !name.length}>Tạo</Button>
    ]

    return (
        <>
            {showBtn &&
                <span onClick={_openModal}>Tạo lô</span>
            }
            <Modal
                visible={isOpen}
                title='Tạo Lô'
                className='GenerateTemplateByQuery'
                onCancel={_closeModal}
                closable={false}
                footer={modalFooter}
            >
                {
                    message && <Alert className="mb-3" message="Lỗi" description={message} type="error" />
                }
                <div>
                    <div className="mb-2">
                        <label htmlFor='listTemplateIds' className='fs-16'>
                            Nhập templates theo từng dòng hoặc cách nhau bằng dấu phẩy:
                        </label>
                        <TextArea rows={6} onChange={_handleChange} placeholder='123456_7'
                            value={string} />
                    </div>

                    <div className='mt-2'>
                        Đã nhập: <span className='font-weight-bold'>{name.length} items</span>
                    </div>

                    <label className="mt-3 font-weight-bold">
                        Người tạo:
                    </label>
                    <Input type="text" placeholder="Nhập tên người tạo"
                        onChange={_handleChangeText}
                    />

                    <label className='mt-3 d-block font-weight-bold'>
                        Đối tác in/ép:
                    </label>
                    {
                        errorPartner ?
                            <Text type='danger'>{errorPartner}</Text> :
                            <Select 
                                onChange={_onChangeSelect} 
                                value={partner} 
                                className='customSelect'
                                dropdownClassName='custom-select-partner'
                            >
                                <Option value={''}>---Hãy chọn 1 đối tác---</Option>
                                {
                                    partners.length > 0 && partners.map(item => {
                                        return <Option key={item._id} value={item._id}>{item.name}</Option>
                                    })
                                }
                            </Select>
                    }

                    <label className='mt-3 d-block font-weight-bold'>
                        Độ ưu tiên:
                    </label>
                    {error ?
                        <Text type='danger'>{error}</Text> :
                        <Radio.Group onChange={_onChangeRadio} value={level}>
                            {
                                levels.length > 0 && levels.map(item => {
                                    return <Radio key={item.key} value={item.key}>{item.value}</Radio>
                                })
                            }
                        </Radio.Group>
                    }
                </div>
            </Modal>
        </>
    )
}

UnpushEmbroideryCreateBatch.propTypes = {
    orders: PropTypes.array // component used orders; pass it from parent
}

export default UnpushEmbroideryCreateBatch
